export default "__VITE_ASSET__DIi6u8ug__"